let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("7mIf9"), load("jXweD"), load("avmx1")]).then(() => parcelRequire('aKvLy'));